import { GeneralInformationTableRowType } from '../types';

export const generalInformationRows: GeneralInformationTableRowType[] = [
  {
    label: 'NAME',
    accessor: 'name',
  },
  {
    label: 'SHORT_NAME',
    accessor: 'shortName',
  },
  {
    label: 'CATEGORY',
    accessor: 'category',
  },
  {
    label: 'WEBSITE',
    accessor: 'website',
  },
  {
    label: 'ADDRESS',
    accessor: 'address',
  },
  {
    label: 'STATE',
    accessor: 'address.state',
  },
  {
    label: 'COORDINATES',
    accessor: 'coordinates',
  },
];
